(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsReleasesEnableController',ScriptsReleasesEnableController);

    ScriptsReleasesEnableController.$inject = ['$uibModalInstance', 'entity', 'ScriptsReleases'];

    function ScriptsReleasesEnableController($uibModalInstance, entity, ScriptsReleases) {
        var vm = this;
        vm.scriptsReleases = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmEnable = function () {
            vm.scriptsReleases.isActive = true;
            ScriptsReleases.update(vm.scriptsReleases,
                function () {
                    $uibModalInstance.close(true);
                },
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
